import {prefix} from "app/config/routes/pp/_cfg";

export const routePPResults = {
    'pp.myScores':   `${prefix}/my-results`,
    'pp.myScore':    (testExerciseId=':testExerciseId') => `${prefix}/my-results/${testExerciseId}`,
    'pp.myInjuries': `${prefix}/my-injuries`,
    'pp.myMeasures': `${prefix}/my-measures`,
}
